import React from 'react';
import { Link } from 'react-router-dom';

const ServicesOneHiringAreaPathology = () => {
    return (
        <>
            <section className="hiring-area pt-120 pb-120">
                <div className="container">
                    <div className="row no-gutters hire-bg-2">
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-img">
                                <img className="img" src="img/doctor/Dr. Alka Gupta.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="hire-text">
                                <h1>Dr. ALKA GUPTA</h1>
                                <p>
                                    M.B.B.S.
                                    <br />
                                    MD (PATHOLOGY)
                                    <br />
                                    24 YEARS OF EXPERIENCE.
                                </p>
                                <Link to="/contact"
                                    className="primary_btn btn-icon btn-icon-green ml-0"><span>+</span>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ServicesOneHiringAreaPathology;